<script>
  import {onMount} from 'svelte';
  import {url} from '@sveltech/routify';

  import Loading from "../../Components/UI/Loading.svelte";
  import Error from "../../Components/UI/Error.svelte";
  import Boton from "../../Components/UI/Boton.svelte";
  import Titulo from "../../Components/UI/Titulo.svelte";
  import ParrillaDeTiposDeJornada from '../../Components/TiposDeJornada/Parrilla/index.svelte';

  import store from '../../Stores/tipos-de-jornada-store';
  import Modal from "../../Components/UI/Modal.svelte";
  import Icono from "../../Components/UI/Icono.svelte";

  onMount(() => store.cargar());
  $: error = $store.error;

  let tipoEliminando, errorEliminacion;
  $: tipoEliminando = $store.tipoEliminando;
  $: errorEliminacion = $store.errorEliminacion;

  const eliminarTipo = e => store.eliminarTipo(e.detail);
  const eliminaTipoDeVerdad = () => store.eliminaTipoDeVerdad(tipoEliminando);

  let activos = true;

  $: listado = $store.listado.filter(x => x.activo === activos);
</script>

<style>
    .nuevo-tipo {
        margin: var(--padding-global) 0;
        text-align: right;
    }

    .filtro {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: var(--padding-global);
        letter-spacing: .15em;
    }

    label {
        margin-left: .5em;
    }

    label:not(:last-child) {
        margin-right: 1em;
    }
</style>

<svelte:head>
    <title>Tipos de jornada</title>
</svelte:head>

<Titulo>Tipos de jornada</Titulo>

{#if error}
    <Error on:cancel={() => error = false}>{$store.error}</Error>
{/if}

{#if $store.cargando }
    <Loading/>
{:else}
    <div>
        <div class="filtro">
            <input type="radio" id="activos" value={true} bind:group={activos}>
            <label for="activos">Activos</label>

            <input type="radio" id="inactivos" value={false} bind:group={activos}>
            <label for="inactivos">Inactivos</label>
        </div>

        <div class="nuevo-tipo">
            <Boton href="{$url('../nuevo')}">Nuevo tipo</Boton>
        </div>

        {#if listado.length }
            <ParrillaDeTiposDeJornada on:eliminar-tipo={eliminarTipo} tiposDeJornada={listado}/>
        {/if}

        {#if listado.length > 6}
            <div class="nuevo-tipo">
                <Boton href="{$url('../nuevo')}">Nuevo tipo</Boton>
            </div>
        {/if}
    </div>
{/if}

{#if tipoEliminando}
    <Modal title="¿Está seguro de que desea eliminar el tipo {tipoEliminando.nombre}?"
           error={errorEliminacion}>
        <div slot="footer" class="opciones">
            <Boton on:click={eliminaTipoDeVerdad} tipo="peligro">
                <Icono>check</Icono>
                Confirmar
            </Boton>
            <Boton on:click={() => tipoEliminando = false} tipo="neutral">
                <Icono>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}